"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toggleRightSidebar = exports.showRightSidebar = exports.setLayoutMessage = exports.hideRightSidebar = exports.changeSidebarType = exports.changeSidebarTheme = exports.changeLayoutWidth = exports.changeLayout = void 0;
var _layout = require("./layout.constant");
// @flow

var changeLayout = function changeLayout(layout) {
  return {
    type: _layout.LayoutActionTypes.CHANGE_LAYOUT,
    payload: layout
  };
};
exports.changeLayout = changeLayout;
var changeLayoutWidth = function changeLayoutWidth(width) {
  return {
    type: _layout.LayoutActionTypes.CHANGE_LAYOUT_WIDTH,
    payload: width
  };
};
exports.changeLayoutWidth = changeLayoutWidth;
var changeSidebarTheme = function changeSidebarTheme(theme) {
  return {
    type: _layout.LayoutActionTypes.CHANGE_SIDEBAR_THEME,
    payload: theme
  };
};
exports.changeSidebarTheme = changeSidebarTheme;
var changeSidebarType = function changeSidebarType(sidebarType) {
  return {
    type: _layout.LayoutActionTypes.CHANGE_SIDEBAR_TYPE,
    payload: sidebarType
  };
};
exports.changeSidebarType = changeSidebarType;
var toggleRightSidebar = function toggleRightSidebar() {
  return {
    type: _layout.LayoutActionTypes.TOGGLE_RIGHT_SIDEBAR,
    payload: null
  };
};
exports.toggleRightSidebar = toggleRightSidebar;
var showRightSidebar = function showRightSidebar() {
  return {
    type: _layout.LayoutActionTypes.SHOW_RIGHT_SIDEBAR,
    payload: null
  };
};
exports.showRightSidebar = showRightSidebar;
var hideRightSidebar = function hideRightSidebar() {
  return {
    type: _layout.LayoutActionTypes.HIDE_RIGHT_SIDEBAR,
    payload: null
  };
};
exports.hideRightSidebar = hideRightSidebar;
var setLayoutMessage = function setLayoutMessage(data) {
  return {
    type: _layout.LayoutActionTypes.LAYOUT_MESSAGE,
    payload: data
  };
};
exports.setLayoutMessage = setLayoutMessage;